import {observer} from "mobx-react";
import * as React from "react";
import Loader from "../Loader/Loader";

interface ILocalState {}
interface IProps {
    propertyName: string
}

@observer
export default class FileInputUploadingFile extends React.Component<IProps> {
    public state: ILocalState = {};

    public render() {
        return (<div className="files-container">
            <Loader/>
            <div className="loading"> {this.getLoadingText()} </div>
        </div>)
    };

    private getLoadingText = () => {
        const {propertyName} = this.props;
        return propertyName === "idImage" || propertyName === "lendioId" ? "Authenticating...": "uploading...";
    }
}



// WEBPACK FOOTER //
// ./src/components/FormFileInput/FileInputUploadingFile.tsx